(function () {
  var seen = Object.create(null);

  function prefetch(href) {
    if (!href || seen[href]) return;
    if (href.charAt(0) !== "/" && href.indexOf(window.location.origin) !== 0) return;
    if (href.indexOf("/cart") === 0 || href.indexOf("/account") === 0) return;
    seen[href] = 1;
    var link = document.createElement("link");
    link.rel = "prefetch";
    link.href = href;
    document.head.appendChild(link);
  }

  function fromEvent(e) {
    var node = e.target;
    if (!node || !node.closest) return;
    var a = node.closest("a[href]");
    if (!a) return;
    if (!a.closest(".cjet-nav, .cjet-mega, .cjet-rail, .cjet-home-rail, .cjet-grid, .cjet-tile, .cjet-logo, .cjet-cut, .cjet-chips, .product-item, .cjet-spot, .cjet-foot")) return;
    prefetch(a.href);
  }

  document.addEventListener("pointerenter", fromEvent, true);
  document.addEventListener("focusin", fromEvent);
  document.addEventListener("touchstart", fromEvent, { passive: true });

  function syncChips(el) {
    var wrap = el.closest(".cjet-chips-wrap, .cjet-hero__cuts-wrap");
    if (!wrap) return;
    var max = el.scrollWidth - el.clientWidth;
    wrap.classList.toggle("is-start", el.scrollLeft <= 2);
    wrap.classList.toggle("is-end", max <= 2 || el.scrollLeft >= max - 2);
  }

  function bindChips() {
    document.querySelectorAll("[data-cjet-chips]").forEach(function (el) {
      if (el.getAttribute("data-cjet-chips-on") === "1") return;
      el.setAttribute("data-cjet-chips-on", "1");
      el.addEventListener("scroll", function () { syncChips(el); }, { passive: true });
      syncChips(el);
    });
  }

  function bindLogos() {
    var wrap = document.querySelector("[data-cjet-logos]");
    if (!wrap || wrap.getAttribute("data-cjet-logos-on") === "1") return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    wrap.setAttribute("data-cjet-logos-on", "1");

    var shift = 0;
    var push = 0;
    var last = window.pageYOffset;
    var frame = 0;

    function tick() {
      push *= 0.9;
      shift += (push - shift) * 0.16;
      if (Math.abs(push) < 0.25 && Math.abs(shift) < 0.25) {
        wrap.style.setProperty("--cjet-logos-shift", "0px");
        frame = 0;
        return;
      }
      wrap.style.setProperty("--cjet-logos-shift", shift.toFixed(2) + "px");
      frame = window.requestAnimationFrame(tick);
    }

    window.addEventListener("scroll", function () {
      var y = window.pageYOffset;
      push += (y - last) * 0.55;
      last = y;
      if (push > 180) push = 180;
      if (push < -180) push = -180;
      if (!frame) frame = window.requestAnimationFrame(tick);
    }, { passive: true });
  }

  function bindSpot() {
    var spot = document.querySelector(".cjet-spot");
    if (!spot || spot.getAttribute("data-cjet-spot-on") === "1") return;
    var radios = spot.querySelectorAll(".cjet-spot__r");
    var stage = spot.querySelector(".cjet-spot__stage");
    var track = spot.querySelector(".cjet-spot__track");
    if (!stage || !track || radios.length < 2) return;
    spot.setAttribute("data-cjet-spot-on", "1");

    var index = 0;
    radios.forEach(function (radio, i) {
      if (radio.checked) index = i;
    });

    function go(next) {
      if (next < 0) next = 0;
      if (next > radios.length - 1) next = radios.length - 1;
      index = next;
      radios[index].checked = true;
      spot.style.setProperty("--cjet-spot-i", String(index));
      spot.style.removeProperty("--cjet-spot-x");
    }

    radios.forEach(function (radio, i) {
      radio.addEventListener("change", function () {
        if (radio.checked) go(i);
      });
    });

    spot.style.setProperty("--cjet-spot-i", String(index));
    spot.classList.add("is-on");

    var startX = 0;
    var startY = 0;
    var dx = 0;
    var active = false;
    var dragging = false;
    var suppressClick = false;
    var pointerId = 0;

    stage.addEventListener("pointerdown", function (e) {
      if (e.button != null && e.button !== 0) return;
      active = true;
      dragging = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      dx = 0;
    });

    stage.addEventListener("pointermove", function (e) {
      if (!active || e.pointerId !== pointerId) return;
      var x = e.clientX - startX;
      var y = e.clientY - startY;
      if (!dragging) {
        if (Math.abs(x) < 8 && Math.abs(y) < 8) return;
        if (Math.abs(y) > Math.abs(x)) {
          active = false;
          return;
        }
        dragging = true;
        spot.classList.add("is-drag");
        if (stage.setPointerCapture) stage.setPointerCapture(pointerId);
      }
      dx = x;
      if (index === 0 && dx > 0) dx *= 0.25;
      if (index === radios.length - 1 && dx < 0) dx *= 0.25;
      spot.style.setProperty("--cjet-spot-x", dx.toFixed(1) + "px");
    }, { passive: false });

    function end(e) {
      if (!active || e.pointerId !== pointerId) return;
      active = false;
      spot.classList.remove("is-drag");
      if (!dragging) return;
      var width = stage.clientWidth || 1;
      var threshold = Math.max(36, width * 0.18);
      var next = index;
      if (dx <= -threshold) next = index + 1;
      else if (dx >= threshold) next = index - 1;
      dragging = false;
      if (Math.abs(dx) >= 8) suppressClick = true;
      go(next);
    }

    stage.addEventListener("pointerup", end);
    stage.addEventListener("pointercancel", end);
    stage.addEventListener("dragstart", function (e) { e.preventDefault(); });
    stage.addEventListener("click", function (e) {
      if (!suppressClick) return;
      suppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function boot() {
    bindChips();
    bindLogos();
    bindSpot();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
